import type { HierarchyRectangularNode } from '@visx/hierarchy/lib/types.js';
import { isUndefined } from 'lodash-es';

import { DEFAULT_BORDER_COLOR } from '../constants.js';
import type { InternalTreeMapNode } from '../types/internal.js';

export const getNodeColor = (
  entry: HierarchyRectangularNode<InternalTreeMapNode>,
): string => {
  const isRootNode = !isUndefined(entry.data.color);
  const color = isRootNode ? entry.data.color : entry.parent?.data.color;
  return color?.Default ?? DEFAULT_BORDER_COLOR;
};
